/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const CoEdit16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.5 9a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0 1a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm7-4a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0 1a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm-6.786 4.007c1.275.067 2.582.604 3.202 1.535a.5.5 0 11-.832.555c-.38-.57-1.323-1.033-2.423-1.091-1.08-.057-2.142.288-2.761 1.113a.5.5 0 11-.8-.6c.881-1.175 2.32-1.58 3.614-1.512zm7-3c1.275.067 2.582.604 3.202 1.535a.5.5 0 01-.832.554c-.38-.57-1.323-1.032-2.423-1.09-1.08-.057-2.142.288-2.761 1.113a.5.5 0 01-.8-.6c.881-1.175 2.32-1.58 3.614-1.512z"
            fill={vars.bdlGray}
        />
    </AccessibleSVG>
);

export default CoEdit16;
